import React, { useEffect } from 'react';
import StanCard from './StanCard'; // Koristimo postojeći StanCard za prikaz kartica stanova

const StanoviPretraga = ({ stanoviData = [], onStanClick, scrollToHome, stanoviPretragaRef }) => {

  const handleStanClick = (stan) => {
    onStanClick(stan);  
  };

  // Automatski skrolujemo na vrh kada se komponenta prikaže, uz kašnjenje da se osigura da je `ref` dostupan
  useEffect(() => {
    const scrollToTop = () => {
      if (stanoviPretragaRef && stanoviPretragaRef.current) {
        stanoviPretragaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    // Dodajemo mali delay kako bismo osigurali da `ref` postoji pre skrolovanja
    const timeoutId = setTimeout(scrollToTop, 100); // Kašnjenje od 100ms

    return () => clearTimeout(timeoutId); // Čistimo timeout nakon izvršenja
  }, [stanoviPretragaRef]);

  return (
    <section ref={stanoviPretragaRef} className="w-full h-auto bg-gray-900 text-gray-900 pt-24">
      <h2 className="text-2xl text-pink-500 font-bold text-center md:text-left mt-8 mb-8 ml-0 md:ml-28">
      Rezultati pretrage
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mr-8 ml-8">
        {stanoviData.length > 0 ? (
          stanoviData.map((stan) => (
            <StanCard
              key={stan.id}  
              title={stan.title}
              location={stan.location}
              price={stan.price}
              area={stan.area}
              rooms={stan.rooms}
              type={stan.type}
              date={stan.date}
              images={stan.images}
              onClick={() => handleStanClick(stan)}  
            />
          ))
        ) : (
          <p className="text-white text-center col-span-full">Nema dostupnih stanova za izabrane parametre.</p>
        )}
      </div>
      <div className="text-center mt-8">
        <button
          onClick={scrollToHome}  
          className="bg-pink-700 text-white py-3 px-6 rounded-full hover:bg-pink-800 hover:text-black transition-colors duration-300 mb-8 shadow-md hover:shadow-[0_0_10px_3px_rgba(219,39,119,1)] transform hover:scale-105 text-sm font-medium"
        >
          Početna
        </button>
      </div>
    </section>
  );
};

export default StanoviPretraga;
